import React, {useState, useEffect} from 'react';
import "./Requests.scss";
import {getRequests_api} from "../../Services/apis";
import {useHistory, useLocation} from "react-router-dom";
import {Collapse} from "react-collapse";
import {Spin} from "antd";
import {SendFile} from "../Chat/ChatServices";


function RequestCard({r}) {

    const history = useHistory()

    const goTo = (uid) => {
        history.push(`/requests-detail/${uid}`)
    }

    const [open, set_open] = useState(false)

    const convertStatus = (st) => {
        switch (st) {
            case 1:
                return "منتظر تایید"
                break;
            case 2:
                return "منتظر پرداخت"
                break;
            case 5:
                return "پرداخت شده"
                break;
            default:
                return ""
        }
    }


    const convertTicketStatusColor = (status)=>{
        switch(status){
            case 1:
                return "rgb(255 187 47)"
                break;
            case 2:
                return "#40a9ff"
                break;
            case 3:
                return "#ea6c6c"
            case 5:
                return "#70bf4e"
                break;
        }
    }

    return (
        <div>
            <div className="request-item clickable-item" onClick={() => {
                // goTo(r.uid)
                set_open(!open)
            }}>
                <div className="request-item-body">
                    <div className="results-item-status">
                        <span style={{backgroundColor:convertTicketStatusColor(r.status)}}
                            className={r.status === 1 ? "results-pending" : "results-completed"}>{convertStatus(r.status)}</span>
                    </div>
                    <div className="results-item-title">
                        <span>{r.prescription_id}</span>
                        {/*<span>{r.uid}</span>*/}
                        <span className="results-item-date">{r.national_code}</span>
                    </div>
                </div>
                <Collapse isOpened={open}>
                    <div className="request-collapse-sec answer-sec">
                        <p>{r.description}</p>
                        <img src={r.files?.length>0?r.files[0].file:""} alt=""/>
                        <span className="comment-btn" onClick={() => {
                            goTo(r.uid)
                        }}>کامنت ها</span>
                    </div>
                </Collapse>
            </div>
        </div>
    )
}

function Requests() {

    const location = useLocation()
    const history = useHistory()
    const [results, set_results] = useState([])

    useEffect(() => {
        getResults()
    }, [])


    const getResults = async () => {
        try {
            const res = await getRequests_api()
            set_loading(false)
            // set_results([
            //     {uid:"1",national_code:"0085062888",prescription_id:"654987",status:"pending"},
            //     {uid:"2",national_code:"0057458985",prescription_id:"988565",status:"pending"},
            //     {uid:"3",national_code:"0015258587",prescription_id:"345767",status:"pending"},
            // ])
            set_results(res.data.results)
        } catch (e) {
            set_loading(false)
            console.error(e)
        }
    }

    const [loading, set_loading] = useState(true);
    const [nav_label, set_nav_label] = useState(null)

    useEffect(() => {
        if (location.state && location.state.navLabel)
            set_nav_label(location.state.navLabel)
    }, [])

    return (
        <div className="results-container">
            <div className="customer-header">
                <span>{nav_label ? nav_label : "درخواست ها"}</span>
                <i className="fa fa-arrow-right back_btn" onClick={()=>history.goBack()}/>
            </div>
            <br/>
            <br/>
            <Spin spinning={loading}>
                <div className="results-list">
                    {results.map(r => {
                        return (
                            <RequestCard r={r}/>
                        )
                    })}
                </div>
            </Spin>
        </div>
    )
}

export default Requests;
